// src/config/live.ts
// Centralized Live page config + tiny helpers.
// IMPORTANT: Defaults match v98/v99 behavior exactly.

export const LIVE_HINT_KEYS = ["startshare", "systemonly", "presentation", "pinhotkeys"] as const;

// ---- Watchdog (UI-side orchestration only; audio stack remains sealed) ----
export const WD_FLAG_KEY = "cb_flag_stt_watchdog";
export const WD_CHECK_INTERVAL_MS = 2000;              // poll check cadence
export const WD_MIN_SESSION_MS = 300_000;              // pre-empt 305s cap (~5s headroom)
export const WD_NO_PARTIAL_MS = 5_000;                 // no partials for >= 5s
export const WD_NO_FINAL_MS = 10_000;                  // no finals for >= 10s

export function readFlag(key: string): boolean {
  try { return (localStorage.getItem(key) || "").toLowerCase() === "true"; } catch { return false; }
}

export function readNumber(key: string, fallback: number): number {
  try {
    const v = Number(localStorage.getItem(key));
    return Number.isFinite(v) && v >= 0 ? v : fallback;
  } catch { return fallback; }
}

// ~1 hour runway by default (12 * 5min). Allow override but clamp to [1, 24].
export const WD_MAX_RECONNECTS_PER_SESSION = Math.max(
  1,
  Math.min(24, readNumber("cb_wd_max_reconnects", 12))
);

// matcher debug flag (localStorage: cb_debug_matcher=true)
export const DEBUG_MATCHER_LOGS = readFlag("cb_debug_matcher");

// dev hooks flag (localStorage: cb_wd_dev_hooks=true)
export const DEV_HOOKS = readFlag("cb_wd_dev_hooks");
